"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var LogoGentuxWordmark =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LogoGentuxWordmark, _PureComponent);

  function LogoGentuxWordmark() {
    _classCallCheck(this, LogoGentuxWordmark);

    return _possibleConstructorReturn(this, _getPrototypeOf(LogoGentuxWordmark).apply(this, arguments));
  }

  _createClass(LogoGentuxWordmark, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          width = _this$props.width,
          height = _this$props.height;
      var color = (0, _Theme.variables)(this.props)[this.props.color];
      return _react.default.createElement(_IconBase.IconBase, _extends({
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        style: style,
        width: width,
        height: height,
        color: color,
        viewBox: "0 0 117.785339 40",
        "aria-labelledby": "title"
      }, this.props), _react.default.createElement("title", null, "Generation Tux Logo"), _react.default.createElement("path", {
        fill: color,
        d: "M13.958 20.965v-.314c-.074-2.238-1.878-3.538-5.084-3.538H4.572c-1.38 0-2.11-.378-2.11-1.298 0-.758.757-1.3 1.46-1.542.732.297 1.57.46 2.598.46 3.41 0 5.276-1.975 5.276-4.41 0-.893-.244-1.732-.758-2.435.298-.38 1.017-.948 1.778-.948 1.15 0 1.924 1.003 1.33 2.395-.026.05-.05.103-.073.154-.028.054-.052.108-.083.165l.045-.082c-.433.93-.685 2-.685 3.183 0 4.33 2.922 6.845 6.385 6.845 2.976 0 5.086-1.622 5.6-4.517l-.162-.054c-.785 2.244-2.516 3.327-4.545 3.327-3.03 0-4.843-2.543-4.843-6.14h9.47c0-3.708-1.706-6.305-5.6-6.305-1.493 0-2.887.534-3.982 1.474.08-.99-.756-1.8-1.823-1.8-1.4 0-2.46 1.246-2.974 2.084-.92-1.11-2.435-1.758-4.356-1.758-3.382 0-5.248 1.975-5.248 4.41 0 1.515.784 2.95 2.272 3.76C2.22 14.434.92 15.327.92 16.68c0 1.65 1.434 2.46 2.95 2.624-2.3.27-3.87 1.298-3.87 2.92 0 2.464 3.49 3.464 6.412 3.464h.2c3.024 0 7.346-1.302 7.346-4.723zm5.668-14.512c2.57 0 3.058 2.435 3.058 5.194H15.84c.134-3.192 1.866-5.194 3.786-5.194zm-5.094 2.222h.007c-.01.016-.023.03-.034.047l.026-.047zM6.52 6.372c1.867 0 2.76 1.812 2.76 3.95 0 2.137-.893 3.95-2.76 3.95-1.84 0-2.732-1.813-2.732-3.95 0-2.138.892-3.95 2.732-3.95zm-.135 18.802c-2.408 0-4.22-1.19-4.22-3.11 0-1.84 1.298-2.733 3.462-2.733h2.976c2.138 0 3.274.758 3.274 2.57 0 1.976-2.083 3.274-5.492 3.274zM86.51 3.34c.97 0 1.697-.728 1.697-1.67C88.207.727 87.48 0 86.51 0s-1.696.727-1.696 1.67c0 .942.728 1.67 1.697 1.67zM27.173 9.13v7.252c0 1.785-.244 2.353-1.542 2.895v.054h5.465v-.053c-1.3-.542-1.542-1.11-1.542-2.895v-3.977c0-3.084 1.57-5.14 3.733-5.14 2.137 0 2.868 1.65 2.868 3.57v5.547c0 1.785-.244 2.353-1.542 2.895v.054h5.465v-.053c-1.3-.542-1.542-1.11-1.542-2.895V10.62c0-3.112-1.732-4.708-4.22-4.708-2.327 0-4.032 1.488-4.762 4.03v-3.76h-4.058v.055c1.298.54 1.677 1.352 1.677 2.894zm46.918 6.602l-.002-.02c.016-1.464.077-3.077.077-5.157 0-3.204-2.1-4.55-5.6-4.55-2.774 0-4.66 1.562-4.66 3.312 0 1.238.862 1.965 1.966 1.965.782 0 1.402-.404 1.536-1.21-.108.053-.242.08-.35.08-.754 0-1.24-.593-1.24-1.428 0-1.184.755-2.208 2.748-2.208 2.208 0 3.124 1.67 3.124 3.635v1.536l-2.047.377c-3.203.593-6.246 1.266-6.246 4.147 0 2.262 1.696 3.34 3.824 3.34 2.262 0 4.2-1.75 4.496-3.636 0 .296.054 1.185.054 1.292.135 1.427.943 2.37 2.397 2.37.59 0 1.11-.14 1.536-.367-1.015-.58-1.605-1.742-1.61-3.478zm-2.456-1.3c-.054 2.505-1.724 3.932-3.42 3.932-1.293 0-2.29-.646-2.29-2.423 0-1.91 1.294-2.88 3.96-3.392l1.804-.35-.054 2.235zm24.77-8.427c-3.85 0-6.595 2.88-6.595 6.812s2.745 6.813 6.595 6.813c3.85 0 6.598-2.88 6.598-6.813s-2.747-6.812-6.598-6.812zm0 13.086c-2.475 0-3.93-2.772-3.93-6.273 0-3.5 1.455-6.274 3.93-6.274 2.48 0 3.933 2.774 3.933 6.274s-1.454 6.274-3.932 6.274zm-51.8 17.41l-2.742-4.22 1.882-2.39c1.264-1.587 1.962-2.367 3.387-3.173v-.054h-3.52v.054c.35.215.51.457.51.806 0 .618-.457 1.37-.994 2.07l-1.64 2.124-1.398-2.15c-.457-.7-1.048-1.48-1.022-2.15 0-.27.08-.512.377-.7v-.054H34.47v.054c1.398.833 2.15 1.478 3.252 3.172l2.124 3.25-2.634 3.36c-.49.625-.893 1.12-1.288 1.54-.742.788-2.068.268-2.096-.816-.002-.05-.003-.104-.003-.158V26.663h-4.032v.054c1.29.537 1.667 1.344 1.667 2.876v3.95c0 3.066-1.72 5.055-3.817 5.055-2.016 0-2.742-1.774-2.742-3.575v-8.37h-7.71v-4.63h-.214c-.377 2.664-2.478 4.71-4.738 5.167v.162h2.585v8.72c0 2.61 1.32 3.928 3.418 3.928 2.423 0 3.392-1.91 3.607-4.494h-.215c-.35 2.018-1.265 3.122-2.584 3.122-1.21 0-1.857-.888-1.857-2.638v-8.638l3.106.006c1.222.003 2.235.982 2.24 2.204v5.757c0 3.09 1.72 4.676 4.085 4.676 2.367 0 4.195-1.505 4.84-4.167v3.897h5.886v-.054c-.376-.242-.51-.564-.51-.887 0-.645.537-1.37 1.02-1.99l2.366-3.063 2.043 3.09c.457.7.995 1.506 1.022 2.15 0 .27-.08.512-.377.7v.054h4.974v-.054c-1.398-.833-2.15-1.478-3.28-3.172zm43.253-20.075V6.275h-8.442V1.642H79.2c-.377 2.665-1.777 4.712-4.04 5.17v.16h1.886V15.7c0 2.61 1.32 3.93 3.42 3.93 2.423 0 3.392-1.912 3.608-4.497h-.216c-.35 2.02-1.265 3.123-2.585 3.123-1.212 0-1.858-.888-1.858-2.638V6.974h3.85c1.22 0 2.22.984 2.223 2.204v7.247c0 1.778-.243 2.343-1.535 2.882v.053h5.44v-.053c-1.294-.54-1.536-1.104-1.536-2.882zm28.393 0V10.69c0-3.097-1.723-4.685-4.2-4.685-2.316 0-4.013 1.48-4.74 4.012V6.274h-4.038v.054c1.292.538 1.67 1.346 1.67 2.88v7.217c0 1.778-.243 2.343-1.536 2.882v.053h5.44v-.053c-1.293-.54-1.536-1.104-1.536-2.882v-3.958c0-3.07 1.562-5.116 3.716-5.116 2.128 0 2.855 1.644 2.855 3.555v5.52c0 1.778-.242 2.343-1.534 2.882v.053h5.44v-.053c-1.293-.54-1.536-1.104-1.536-2.882zM60.944 6.005c-2.396 0-3.797 2.262-4.39 4.793V6.274h-4.038v.054c1.293.538 1.67 1.346 1.67 2.88v7.217c0 1.778-.243 2.343-1.536 2.882v.053h6.248v-.053c-1.535-.458-2.343-1.104-2.343-2.882v-3.123c0-3.15 1.59-5.816 3.42-5.816.915 0 1.454.51 1.454 1.238 0 .593-.324 1.024-.81 1.212.136.19.486.35.89.35.86 0 1.938-.646 1.938-2.127 0-1.294-1.077-2.155-2.504-2.155zM47.616 18.39c-3.016 0-4.82-2.53-4.82-6.11h9.424c0-3.69-1.696-6.275-5.574-6.275-3.393 0-6.274 2.773-6.274 6.812 0 4.31 2.908 6.813 6.355 6.813 2.962 0 5.062-1.616 5.574-4.497l-.16-.054c-.782 2.234-2.505 3.31-4.524 3.31zM46.62 6.544c2.557 0 3.042 2.424 3.042 5.17H42.85c.134-3.177 1.857-5.17 3.77-5.17z"
      }));
    }
  }]);

  return LogoGentuxWordmark;
}(_react.PureComponent);

LogoGentuxWordmark.displayName = 'LogoGentuxWordmark'; // Prop Types

LogoGentuxWordmark.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
LogoGentuxWordmark.defaultProps = {
  className: '',
  style: {},
  width: '117.785339',
  height: '40',
  color: 'black'
};

var _default = (0, _styledComponents.withTheme)(LogoGentuxWordmark);

exports.default = _default;